/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Preview_Action_ContinueInputs */

const en_us2_search_preview_action_continue = /** @type {(inputs: Search_Preview_Action_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to the set where you left off.`)
};

const pt_br2_search_preview_action_continue = /** @type {(inputs: Search_Preview_Action_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volta para a série em que você parou.`)
};

const es_419_search_preview_action_continue = /** @type {(inputs: Search_Preview_Action_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuelve a la serie donde te quedaste.`)
};

const pt_pt2_search_preview_action_continue = /** @type {(inputs: Search_Preview_Action_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volta à série onde paraste.`)
};

const fr_fr2_search_preview_action_continue = /** @type {(inputs: Search_Preview_Action_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour à la série où tu en étais.`)
};

const de_de2_search_preview_action_continue = /** @type {(inputs: Search_Preview_Action_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zu dem Satz, bei dem du aufgehört hast.`)
};

const it_it2_search_preview_action_continue = /** @type {(inputs: Search_Preview_Action_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna alla serie dove eri rimasto.`)
};

/**
* | output |
* | --- |
* | "Back to the set where you left off." |
*
* @param {Search_Preview_Action_ContinueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_preview_action_continue = /** @type {((inputs?: Search_Preview_Action_ContinueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Preview_Action_ContinueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_preview_action_continue(inputs)
	if (locale === "es-419") return es_419_search_preview_action_continue(inputs)
	if (locale === "pt-PT") return pt_pt2_search_preview_action_continue(inputs)
	if (locale === "fr-FR") return fr_fr2_search_preview_action_continue(inputs)
	if (locale === "de-DE") return de_de2_search_preview_action_continue(inputs)
	if (locale === "it-IT") return it_it2_search_preview_action_continue(inputs)
	return en_us2_search_preview_action_continue(inputs)
});
export { search_preview_action_continue as "search.preview_action_continue" }